/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ErrorLogCompassOnAzure
 */
export interface ErrorLogCompassOnAzure {
    /**
     * 
     * @type {string}
     * @memberof ErrorLogCompassOnAzure
     */
    firmware_version: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorLogCompassOnAzure
     */
    compass_uuid: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorLogCompassOnAzure
     */
    error_code: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorLogCompassOnAzure
     */
    line_number: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorLogCompassOnAzure
     */
    module: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorLogCompassOnAzure
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof ErrorLogCompassOnAzure
     */
    creation_timestamp: number;
    /**
     * 
     * @type {string}
     * @memberof ErrorLogCompassOnAzure
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorLogCompassOnAzure
     */
    auth_id: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorLogCompassOnAzure
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorLogCompassOnAzure
     */
    _etag: string;
    /**
     * 
     * @type {number}
     * @memberof ErrorLogCompassOnAzure
     */
    _ts: number;
}

/**
 * Check if a given object implements the ErrorLogCompassOnAzure interface.
 */
export function instanceOfErrorLogCompassOnAzure(value: object): value is ErrorLogCompassOnAzure {
    if (!('firmware_version' in value) || value['firmware_version'] === undefined) return false;
    if (!('compass_uuid' in value) || value['compass_uuid'] === undefined) return false;
    if (!('error_code' in value) || value['error_code'] === undefined) return false;
    if (!('line_number' in value) || value['line_number'] === undefined) return false;
    if (!('module' in value) || value['module'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('creation_timestamp' in value) || value['creation_timestamp'] === undefined) return false;
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('auth_id' in value) || value['auth_id'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('_etag' in value) || value['_etag'] === undefined) return false;
    if (!('_ts' in value) || value['_ts'] === undefined) return false;
    return true;
}

export function ErrorLogCompassOnAzureFromJSON(json: any): ErrorLogCompassOnAzure {
    return ErrorLogCompassOnAzureFromJSONTyped(json, false);
}

export function ErrorLogCompassOnAzureFromJSONTyped(json: any, ignoreDiscriminator: boolean): ErrorLogCompassOnAzure {
    if (json == null) {
        return json;
    }
    return {
        
        'firmware_version': json['firmware_version'],
        'compass_uuid': json['compass_uuid'],
        'error_code': json['error_code'],
        'line_number': json['line_number'],
        'module': json['module'],
        'type': json['type'],
        'creation_timestamp': json['creation_timestamp'],
        'org_code': json['org_code'],
        'auth_id': json['auth_id'],
        'id': json['id'],
        '_etag': json['_etag'],
        '_ts': json['_ts'],
    };
}

export function ErrorLogCompassOnAzureToJSON(json: any): ErrorLogCompassOnAzure {
    return ErrorLogCompassOnAzureToJSONTyped(json, false);
}

export function ErrorLogCompassOnAzureToJSONTyped(value?: ErrorLogCompassOnAzure | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firmware_version': value['firmware_version'],
        'compass_uuid': value['compass_uuid'],
        'error_code': value['error_code'],
        'line_number': value['line_number'],
        'module': value['module'],
        'type': value['type'],
        'creation_timestamp': value['creation_timestamp'],
        'org_code': value['org_code'],
        'auth_id': value['auth_id'],
        'id': value['id'],
        '_etag': value['_etag'],
        '_ts': value['_ts'],
    };
}

